import React, { useState } from "react";
import { useInView } from "react-intersection-observer";

function Project({ project, isLeftAligned }) {
    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const nextImage = () => {
        if (project.images && project.images.length > 1) {
            setCurrentImageIndex((prev) => (prev + 1) % project.images.length);
        }
    };

    const prevImage = () => {
        if (project.images && project.images.length > 1) {
            setCurrentImageIndex((prev) =>
                prev === 0 ? project.images.length - 1 : prev - 1
            );
        }
    };

    const goToImage = (index) => setCurrentImageIndex(index);

    const metaItems = [
        { label: "Type", value: project.Dissection },
        { label: "Location", value: project.location },
        { label: "Client", value: project.Client },
        { label: "Consultant", value: project.Consultant },
    ];

    return (
        <div
            ref={ref}
            className={`project ${!isLeftAligned ? 'project--reverse' : ''} ${inView ? 'project--visible' : ''}`}
        >
            {/* ── Image Carousel ── */}
            <div className="project__carousel">
                <div className="project__carousel-inner">
                    {project.images ? (
                        project.images.map((img, idx) => (
                            <img
                                key={idx}
                                src={img}
                                alt={`${project.title} – ${idx + 1}`}
                                className={`project__image ${idx === currentImageIndex ? 'project__image--active' : ''}`}
                            />
                        ))
                    ) : (
                        <img
                            src={project.imageUrl}
                            alt={project.title}
                            className="project__image project__image--active"
                        />
                    )}
                </div>

                {project.images && project.images.length > 1 && (
                    <>
                        <button
                            className="project__arrow project__arrow--prev"
                            onClick={prevImage}
                            aria-label="Previous image"
                        >
                            ❮
                        </button>
                        <button
                            className="project__arrow project__arrow--next"
                            onClick={nextImage}
                            aria-label="Next image"
                        >
                            ❯
                        </button>

                        <div className="project__dots">
                            {project.images.map((_, index) => (
                                <button
                                    key={index}
                                    className={`project__dot ${index === currentImageIndex ? 'project__dot--active' : ''}`}
                                    onClick={() => goToImage(index)}
                                    aria-label={`Go to image ${index + 1}`}
                                />
                            ))}
                        </div>
                    </>
                )}
            </div>

            {/* ── Info Panel ── */}
            <div className="project__info">
                <h3 className="project__title">{project.title}</h3>
                <div className="project__meta">
                    {metaItems.map((item, i) => (
                        <div className="project__meta-row" key={i}>
                            <span className="project__meta-label">{item.label}</span>
                            <span className="project__meta-value">{item.value}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Project;
